import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of as observableOf } from 'rxjs';

@Injectable()
export class StrategyIdResolve implements Resolve<number> {
  constructor() { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<number> {
    const strategyId = Number.parseInt(route.paramMap.get('strategyId'), 10);
    return observableOf(strategyId);
  }
}
